export const brand = {
  name: 'Protocollo Settembre Giallo™',
  short: 'PROTOCOLLO SETTEMBRE GIALLO',
  tag: 'Soluzione professionale per la salute mentale',
}

export const checkoutUrl = 'https://protocollo-settembre-giallo.impultienda.ar'

export const currencyNote =
  'Il sistema elaborerà automaticamente il tuo pagamento nella valuta locale del tuo paese al tasso di cambio ufficiale.'

export const mockups = {
  kit: 'https://cdn.magicpatterns.com/uploads/cMFNJCm4WRUJxLR34nt3eB/mockup2.png',
  deck: 'https://cdn.magicpatterns.com/uploads/2PwDHUsnFqxeAbZSQfTF3R/1.png',
  deckCards: 'https://cdn.magicpatterns.com/uploads/vBa18C83RKZQX3CG7Bn3j1/2.png',
  cardsGifts: 'https://cdn.magicpatterns.com/uploads/3xCyXdxykbS3WrSeYBuq4V/7.png',
  bookmarksDetail: 'https://cdn.magicpatterns.com/uploads/gzaoat9NT6Uuw3d1v5uYDX/6.png',
  cards: 'https://cdn.magicpatterns.com/uploads/9JjD9yqbWvW4sCa4WCpae7/3.png',
  bookmarks: 'https://cdn.magicpatterns.com/uploads/1tdBBLfgK9RgVw9xcQrUeM/8.png',
}

export const heroFacts: string[] = [
  'Accesso immediato',
  '50 pagine',
  '300+ elementi',
  'Kit 3 in 1',
]

export interface Quote {
  initials: string
  quote: string
  author: string
  role: string
  city: string
}

export const quickQuotes: Quote[] = [
  {
    initials: 'GR',
    quote:
      'Avevo 3 ore per preparare la mia lezione. Con questo kit ho stampato, organizzato e consegnato materiale professionale. I miei studenti chiedono se ce n’è di più.',
    author: 'Dott.ssa Giulia Riva',
    role: 'Psicologa',
    city: 'Milano',
  },
  {
    initials: 'MV',
    quote:
      'Come insegnante, mi ha risparmiato ore di ricerca su Google. Viene tutto: il mazzo, le carte, i segnalibri. Pronto per l’uso.',
    author: 'Prof. Marco Valenti',
    role: 'Docente Secondario',
    city: 'Roma',
  },
  {
    initials: 'EF',
    quote:
      'Per le Risorse Umane è stato oro puro. Abbiamo fatto dinamiche in team, distribuito i segnalibri e creato un dialogo reale sulla salute mentale.',
    author: 'Dott.ssa Elena Ferrari',
    role: 'Direttrice Talento',
    city: 'Torino',
  },
  {
    initials: 'CM',
    quote:
      'L’impatto è stato immediato. I dipendenti non hanno solo ricevuto un foglio carino, hanno ricevuto uno strumento di contenimento reale.',
    author: 'Dott.ssa Chiara Moretti',
    role: 'Leader di People',
    city: 'Bologna',
  },
]

export const deepQuotes: Quote[] = [
  {
    initials: 'JP',
    quote:
      'Ho usato il mazzo in un workshop con 20 adolescenti. Ho visto ragazzi emotivamente chiusi aprirsi e parlare di cose che non avevano mai condiviso. È stato trasformativo. Ora chiedo più kit per altri gruppi. Inoltre, i bonus mi hanno risparmiato ore di preparazione.',
    author: 'Dott. Juan Pérez',
    role: 'Psicopedagogo',
    city: 'Santiago del Cile',
  },
  {
    initials: 'AL',
    quote:
      'Ho stampato tutto il pomeriggio, l’ho usato il giorno dopo. I miei 40 studenti si sono sentiti valorizzati nel ricevere qualcosa di bello e con proposito. Alcuni mi dicono che l’hanno messo nel portafoglio. È incredibile. La guida di implementazione è stata fondamentale per farlo senza improvvisare.',
    author: 'Prof. Alejandra López',
    role: 'Insegnante',
    city: 'Lima, Perù',
  },
  {
    initials: 'PG',
    quote:
      'Per le Risorse Umane è stato oro puro. Abbiamo fatto dinamiche in team, distribuito i segnalibri e creato un dialogo reale sulla salute mentale senza sembrare corporativi. Il clima lavorativo è migliorato notevolmente. Il kit di comunicazione mi ha aiutato a presentarlo con professionalità.',
    author: 'Dott.ssa Patricia Gómez',
    role: 'Direttrice Talento',
    city: 'Bogotá, Colombia',
  },
  {
    initials: 'GR',
    quote:
      'Ho uno studio di psicologia da 15 anni. Non avevo mai visto un materiale così ben pensato per aprire conversazioni difficili. La mia cliente in crisi si è portata a casa un segnalibro e mi ha detto che quando l’ha visto, si è sentita meno sola. I 3 bonus hanno fatto la differenza.',
    author: 'Dott.ssa Gabriela Rodríguez',
    role: 'Psicologa',
    city: 'Palermo, Sicilia',
  },
]

export interface ProductImage {
  src: string
  alt: string
}

export interface Product {
  emoji: string
  eyebrow: string
  title: string
  lead: string
  body: string
  images: ProductImage[]
}

export const products: Product[] = [
  {
    emoji: '🃏',
    eyebrow: 'Prodotto 1',
    title: 'Mazzo Riflessivo',
    lead: '36 carte con domande riflessive per parlare di salute mentale e valorizzazione della vita durante la campagna di Settembre Giallo.',
    body: 'Con una proposta accessibile, sensibile e facile da applicare, il materiale aiuta ad aprire lo spazio per conversazioni importanti sulla salute mentale, i sentimenti, l’autocura, il supporto e la valorizzazione della vita, rendendo le azioni di Settembre Giallo molto più umane e speciali.',
    images: [
      {
        src: mockups.deck,
        alt: 'Scatola del Mazzo di Settembre Giallo insieme a una carta con domanda riflessiva durante una dinamica di gruppo',
      },
      {
        src: mockups.deckCards,
        alt: 'Foglio del Mazzo Riflessivo con nove carte di domande numerate visualizzato su un tablet',
      },
    ],
  },
  {
    emoji: '💌',
    eyebrow: 'Prodotto 2',
    title: '120 Carte Motivazionali',
    lead: 'Rendi le tue azioni di Settembre Giallo ancora più speciali.',
    body: '120 carte con messaggi accoglienti e motivazionali, perfette per distribuire individualmente o trasformare in bei regali con cioccolatini, caramelle, lecca-lecca, dolcetti, matite e molto altro. Un modo semplice e amorevole di diffondere messaggi di speranza e valorizzazione della vita.',
    images: [
      {
        src: mockups.cards,
        alt: 'Campione delle 120 carte motivazionali illustrate per Settembre Giallo',
      },
      {
        src: mockups.cardsGifts,
        alt: 'Carte motivazionali usate come regali: sacchettini di caramelle con nastro giallo e lecca-lecca con carta',
      },
    ],
  },
  {
    emoji: '📌',
    eyebrow: 'Prodotto 3',
    title: '120 Segnalibri di Pagina',
    lead: 'Un regalo carino e affettivo da distribuire nelle scuole, aziende, chiese, progetti, lezioni, gruppi e azioni di sensibilizzazione di Settembre Giallo.',
    body: 'Trasforma le tue azioni di Settembre Giallo in momenti ancora più speciali, accoglienti e pieni di significato. Questo materiale riunisce 120 segnalibri con diversi stili, illustrazioni e messaggi di valorizzazione della vita, cura, speranza e incoraggiamento.',
    images: [
      {
        src: mockups.bookmarks,
        alt: 'Campione dei 120 segnalibri con diversi design e messaggi di valorizzazione della vita',
      },
      {
        src: mockups.bookmarksDetail,
        alt: 'Cinque segnalibri stampati con girasoli e messaggi di speranza su una scrivania in legno',
      },
    ],
  },
]

export const deliverables: string[] = [
  '20 pagine in PDF con le 120 carte motivazionali',
  '6 pagine del Mazzo Riflessivo (36 carte + scatola da assemblare e conservare)',
  '24 pagine di Segnalibri (120 opzioni diverse di design)',
  'Guida di Implementazione Professionale (istruzioni passo passo per guidare dinamiche)',
  'Tutti i file in PDF ad alta risoluzione pronti per la stampa',
  'I PDF ti arrivano direttamente via email, con accesso immediato',
  'File non modificabile (ottimizzato per stampare senza cambiamenti)',
]

export interface Bonus {
  tag: string
  title: string
  subtitle: string
  lead: string
  includes: string[]
  value: string
}

export const bonuses: Bonus[] = [
  {
    tag: 'Bonus #1',
    title: 'Guida Express di Implementazione',
    subtitle: '“Campagna Pronta in 30 Minuti”',
    lead: 'Trasforma il Protocollo Settembre Giallo™ in un’azione pronta da applicare nella tua scuola, studio, azienda o istituzione in meno di 30 minuti.',
    includes: [
      '5 piani di utilizzo secondo il contesto (scuola, studio, azienda, chiesa, workshop)',
      'Checklist di preparazione preliminare',
      'Mini protocollo di apertura e chiusura dell’attività',
      'Guida di utilizzo di carte, mazzo e segnalibri',
      'Piano express di 30 minuti stampabile',
    ],
    value: '9,00 €',
  },
  {
    tag: 'Bonus #2',
    title: 'Checklist Professionale di Stampa e Assemblaggio',
    subtitle: '“Tutto Pronto per Consegnare”',
    lead: 'Stampa, ritaglia e presenta il tuo kit come se fosse un materiale istituzionale premium, senza errori, senza sprechi e senza spendere di più.',
    includes: [
      'Tabella di materiali consigliati per contesto',
      'Guida ai tipi di carta suggeriti (grammatura, tipo, finitura)',
      'Calcolatore manuale di quantità secondo il numero di persone',
      'Istruzioni di taglio e assemblaggio',
      'Idee di presentazione e gadget con proposito',
      'Testo pronto da inviare alla tipografia',
    ],
    value: '7,00 €',
  },
  {
    tag: 'Bonus #3',
    title: 'Kit di Comunicazione Istituzionale',
    subtitle: '“Pronto per Convocare e Presentare”',
    lead: 'Annuncia, presenta e accompagna la tua azione di Settembre Giallo con messaggi professionali pronti da copiare, incollare e inviare.',
    includes: [
      '12 messaggi istituzionali copiabili (scuola, azienda, studio, comunità)',
      'Testi per WhatsApp, email e bacheca',
      'Testi di apertura e chiusura dell’attività',
      'Disclaimer sensibili',
      'Messaggio post-campagna',
      'Versione mobile-friendly',
    ],
    value: '5,00 €',
  },
]

export const offer = {
  listPrice: '47,00 €',
  price: '19',
  currency: '€',
  subtitle: 'Offerta di Lancio | Accesso a vita',
  detail:
    'Include: 50 pagine di materiale professionale + 3 bonus esclusivi + Guida completa di implementazione + Supporto via email.',
  cta: '🟢 Acquista ora per soli 19 €',
}

export const trustItems = [
  { icon: 'lock', label: 'Pagamento 100% sicuro' },
  { icon: 'check', label: 'Accesso immediato' },
  { icon: 'money', label: 'Garanzia 7 giorni' },
  { icon: 'mail', label: 'Supporto via email' },
] as const

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'Come ricevo il materiale?',
    answer:
      'Subito dopo aver confermato il pagamento, i PDF ti arrivano direttamente alla tua email. Non ci sono piattaforme né passaggi extra: apri la mail e hai già le 50 pagine + i 3 bonus per salvare o stampare da qualsiasi dispositivo (computer, cellulare o tablet).',
  },
  {
    question: 'Devo modificarli o sono pronti per la stampa?',
    answer:
      'Sono pronti al 100% per la stampa. Non sono modificabili. Sono ottimizzati in PDF perché la qualità sia impeccabile in qualsiasi tipografia. Se ti servono modifiche specifiche, non è il prodotto adatto. Ma il bonus #2 ti insegna esattamente come personalizzarli senza modificarli.',
  },
  {
    question: 'Qual è la risoluzione e il formato per la stampa?',
    answer:
      '300 DPI, il che garantisce una resa nitida su qualsiasi tipo di stampante (laser, inkjet, tipografia professionale). Tutti i file sono a colori e pronti per carta da 200g+. Formati: A4 e A3 a seconda del caso.',
  },
  {
    question: 'Posso usarlo in più gruppi, scuole o istituzioni?',
    answer:
      'Sì. Una volta acquistato, puoi stampare tutte le copie che ti servono per la tua scuola, studio, azienda o organizzazione. La licenza personale te lo permette per uso istituzionale senza limiti.',
  },
  {
    question: 'In che valuta pago se non sono in Italia?',
    answer:
      'Il prezzo è espresso in euro (19 €) perché sia lo stesso in tutta Europa. Il sistema elaborerà automaticamente il tuo pagamento nella valuta locale del tuo paese al tasso di cambio ufficiale, quindi al checkout vedrai l’importo esatto nella tua valuta, senza calcoli né sorprese.',
  },
  {
    question: 'Cosa faccio se qualcuno entra in crisi durante un’attività?',
    answer:
      'La Guida di Implementazione (Bonus #1) ti prepara esattamente a questo. Il protocollo include istruzioni di contenimento sul momento e come indirizzare a un professionista della salute mentale se necessario. Questa non è terapia, è prevenzione con cura e sensibilità.',
  },
  {
    question: 'Vale davvero la pena investire 19 €?',
    answer:
      'Confronta: 1 ora di progettazione grafica costa 30 € e oltre. 1 sessione di consulenza HR costa 50 € e oltre. 1 conferenza professionale sulla salute mentale costa 80 € e oltre. Tu stai acquistando 50 pagine professionali + 3 bonus (implementazione, stampa, comunicazione) + guida strategica per 19 €. È un investimento di 4-5 ore di lavoro professionale al prezzo di due caffè.',
  },
]
